import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import {
  UpdateLLMProjectInput,
  UpdateLLMProjectMutation,
} from "../API";

export async function updateLLMProjectSummaryEmail(
  values: UpdateLLMProjectInput
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {
  const input: UpdateLLMProjectInput = {
    id: values.id,
  };

  if (values.summaryEmailPeriod !== undefined) {
    input.summaryEmailPeriod = values.summaryEmailPeriod;
  }
  if (values.summaryEmailAddresses !== undefined) {
    input.summaryEmailAddresses = values.summaryEmailAddresses;
  }
  if (values.lastSummaryEmailSentAt !== undefined) {
    input.lastSummaryEmailSentAt = values.lastSummaryEmailSentAt;
  }

  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input,
    })
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
